/**
 * @auth water
 * 自动收集全局公共组件
 * 建议尽量用纯组件
 * 并用app开头
 * 单例组件建议用the开头
 */
const files = require.context('./', true, /\.vue$/)
const path = require('path')

const install = Vue => {
  files.keys().forEach(key => {
    const componentConfig = files(key)
    const component = componentConfig.default || componentConfig
    const componentName = component.name || path.basename(key, '.vue')
    Vue.component(componentName, component)
  })
}
export default install